<template>
    <div class="card">
        <template v-if="!isSubSuccess">
            <div class="content p_24">
                <template v-if="date.timer">
                    <p class="p_mb24 time">
                        <img src="../../assets/lives/right_line.png" alt="">
                        <span>倒计时：{{ timeInterval }}</span>
                        <img src="../../assets/lives/left_line.png" alt="">
                    </p>
                </template>
                <h3>{{ date.cardType == 1 ? '选项卡' : '评价调研' }}</h3>
                <p class="p_ml24">{{ date.desc }}</p>
                <template v-if="date.cardType == 1">
                    <div class="check">
                        <span v-for="(item, index) in date.options" :key="index"
                            :style="date.optionType == 3 ? { width: '100%' } : { width: '45%' }"
                            :class="selectList.indexOf(item) != -1 ? 'check_select' : ''" @click="selectCheck(item)"
                            class="check_item p_over">{{ item }}</span>
                    </div>
                </template>
                <template v-if="date.cardType == 2">
                    <div class="star">
                        <div class="p_mb24 star_item">
                            <img @click="starClick(index)" v-for="(item, index) in 5" :src="selectStar.indexOf(index) != -1 ? starImg.active : starImg.default" alt="" style="width: 28px; height: 28px;">
                        </div>
                        <span>五星最满意</span>
                        <el-input type="textarea" :rows="3" placeholder="我有话要说..." v-model="inputValue" style="margin: 12px 0 24px 0;">
                        </el-input>
                    </div>
                </template>
                <el-button @click="submit" type="primary" round style="width: 100%;">提交</el-button>
            </div>
        </template>
        <template v-if="isSubSuccess">
            <div class="content">
                <div class="bgimg"></div>
                <p style="color: #256EE7; font-size: 20px;">提交成功</p>
                <el-button @click="close()" type="primary" round style="margin: 24px;">我知道了</el-button>
            </div>
        </template>
        <template v-if="!isSubSuccess">
            <i @click="close" class="el-icon-circle-close"
                style="color: white; font-size: 35px; margin-top: 20px; cursor: pointer;"></i>
        </template>
    </div>
</template>

<script>

var cardInterval
export default {
    name: "card",
    props: ['cardDate'],
    data() {
        return {
            isSubSuccess: false,
            selectList: [],
            date: {},
            timeInterval: 0,
            starsValue: 0,
            inputValue: "",
            selectStar:[],
            starImg:{
                default:require("../../assets/lives/wj_emp.png"),
                active:require("../../assets/lives/wj_full.png"),
            }
        }
    },

    watch: {
        cardDate: function (news, olds) {
            if (news && this.isSubSuccess) this.isSubSuccess = false
            this.initDate()
        }
    },

    mounted() {
        this.initDate()
    },

    methods: {
        // 初始化卡片数据
        initDate() {
            var that = this
            clearInterval(this.cardInterval)
            if (that.cardDate.cardType == 1) {
                var option = ""
                if (that.cardDate.optionType == 1) {
                    option = that.cardDate.aF.split(',')
                } else if (that.cardDate.optionType == 2) {
                    option = [that.cardDate.yes, that.cardDate.ng]
                } else if (that.cardDate.optionType == 3) {
                    option = that.cardDate.selfOption.split(',')
                }
                that.date = {
                    ...that.cardDate,
                    options: option
                }
            } else {
                for(var i=0; i<that.cardDate.starsDefault; i++){
                    that.selectStar.push(i)
                }
                that.date = that.cardDate
            }
            if (that.cardDate.timer > 0) {
                that.timeInterval = that.cardDate.timer
                cardInterval = setInterval(() => {
                    if (that.timeInterval <= 0) {
                        that.close()
                        clearInterval(that.cardInterval)
                    }
                    that.timeInterval--
                }, 1000)
            }
        },

        starClick(i){
            var isHaveStar = this.selectStar.indexOf(i) == -1 ? false : true
            if(isHaveStar){
                this.selectStar = this.selectStar.filter(item => item < i)
            }else{
                var arr = []
                for(var j=0; j<=i; j++){
                    arr.push(j)
                    this.selectStar.push(j)  
                }
            }
        },
        // 选项选中处理
        selectCheck(str) {
            var i = this.selectList.indexOf(str)
            if (i != -1) {
                this.selectList.splice(i, 1)
            } else {
                if (this.date.isRadio == 1) this.selectList = []
                this.selectList.push(str)
            }
        },
        // 提交卡片数据
        submit() {
            if(this.date.cardType == 1 && !this.selectList){
                this.$message.error('请至少选择一个答案')
                return;
            }
            var params = {
                cardId: this.date.cardId,
                channel: sessionStorage.getItem('channel_info') ? sessionStorage.getItem('channel_info').title : "",
                channelId: sessionStorage.getItem('channel_info') ? sessionStorage.getItem('channel_info').channel_id : "",
                selected: this.date.cardType == 1 ? this.selectList.join(',') : this.selectStar.length,
                msg: this.date.cardType == 1 ? "" : this.inputValue,
                ocRoomId: localStorage.getItem('room_id'),
            }
            this.$api.SubmitCardList(params).then(res => {
                if (res.data.status == 200) {
                    this.isSubSuccess = true
                }
            })
        },
        // 关闭卡片按钮
        close() {
            this.$emit('close')
        }
    },
}
</script>

<style lang="scss">
.p {
    &_over {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &_24 {
        padding: 24px;
    }

    &_ml24 {
        margin: 24px 0;
    }

    &_mx24 {
        margin: 0 24px;
    }

    &_m24 {
        margin: 24px;
    }

    &_mb24 {
        margin-bottom: 24px;
    }
}

.card {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .content {
        width: 242px;
        min-height: 200px;
        background-color: rgb(255, 255, 255);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .check {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            &_item {
                display: inline-block;
                width: 95px;
                border-radius: 20px;
                background-color: #eff3ff;
                line-height: 40px;
                font-size: 15px;
                color: #777;
                margin-bottom: 16px;
                border: 2px solid #eff3ff;
            }

            &_select {
                border: 2px solid #256EE7;
                color: #256EE7;
            }
        }

        .star_item{
            display: flex;
            justify-content: space-around;
            padding: 0 10px;
        }

        .bgimg {
            height: 158px;
            background: url('../../assets/lives/sumbit_success.png') no-repeat;
            background-size: contain;
        }

        .time {
            color: rgb(37, 110, 231);
            font-size: 16px;
        }
    }

}
</style>